import EditorJS from '@editorjs/editorjs';
export default EditorJS;
